export const GET_TRANSACTIONS_TYPES_REQUEST = 'GET_TRANSACTIONS_TYPES_REQUEST';
export const GET_TRANSACTIONS_TYPES_SUCCESS = 'GET_TRANSACTIONS_TYPES_SUCCESS';
export const GET_TRANSACTIONS_TYPES_FAILURE = 'GET_TRANSACTIONS_TYPES_FAILURE';

export const SAVE_CLIENT_TAX_CODES_MANUAL = 'SAVE_CLIENT_TAX_CODES_MANUAL';
export const SAVE_CLIENT_TAX_CODES_MANUAL_SUCCESS = 'SAVE_CLIENT_TAX_CODES_MANUAL_SUCCESS';
export const SAVE_CLIENT_TAX_CODES_MANUAL_FAILURE = 'SAVE_CLIENT_TAX_CODES_MANUAL__FAILURE';

export const SAVE_CLIENT_TAX_CODES_MANUAL_RATES = 'SAVE_CLIENT_TAX_CODES_MANUAL_RATES';
export const SAVE_CLIENT_TAX_CODES_MANUAL_RATES_SUCCESS =
  'SAVE_CLIENT_TAX_CODES_MANUAL_RATES_SUCCESS';
export const SAVE_CLIENT_TAX_CODES_MANUAL_RATES_FAILURE =
  'SAVE_CLIENT_TAX_CODES_MANUAL_RATES_FAILURE';

export const CLEAR_SAVED_TAX_RATES = 'CLEAR_SAVED_TAX_RATES';
